import React, { useEffect, useState } from "react";
import { oficinasApi, municipiosApi } from "../../../api/catalogosApi";

// IPD_PATCH05D3B_R3
// Consulta informativa, sin inventario ni requisiciones.

const IDS_PENDIENTES = Object.freeze([
  "OFI_2e79f3fc-6ff1-4c00-97d2-d41f1e36eb49",
  "OFI_fb44adb1-9603-4e25-a2ff-450cb882f9c8",
  "OFI_54a33014-ecf7-4272-ad67-1ad9e2161319",
  "OFI_49228c43-d8ec-4c5f-a185-617f08cd5e3f"
]);

const ID_SET = new Set(IDS_PENDIENTES);

function resolverPendientes(oficinas, municipios) {
  if (!Array.isArray(oficinas) || !Array.isArray(municipios)) {
    throw new Error("CATALOGO_INVALIDO");
  }

  const municipiosMap = new Map(
    municipios
      .filter(m => m?.id && m.activo !== false)
      .map(m => [m.id, m])
  );

  const resultado = new Map();

  for (const oficina of oficinas) {
    if (!oficina || !ID_SET.has(oficina.id) || oficina.activo === false) {
      continue;
    }

    if (resultado.has(oficina.id)) {
      throw new Error("OFICINA_DUPLICADA");
    }

    const municipio = municipiosMap.get(oficina.municipioId);

    if (!municipio || !oficina.nombre || !municipio.nombre) {
      throw new Error("MUNICIPIO_INVALIDO");
    }

    resultado.set(oficina.id, {
      id: oficina.id,
      nombre: oficina.nombre,
      municipio: municipio.nombre
    });
  }

  if (resultado.size !== 4) {
    throw new Error("CATALOGO_INCOMPLETO");
  }

  return IDS_PENDIENTES.map(id => resultado.get(id));
}

export default function PendientesCatalogoInsumos() {
  const [estado, setEstado] = useState("cargando");
  const [oficinas, setOficinas] = useState([]);

  useEffect(() => {
    let activo = true;

    async function consultar() {
      try {
        const [listaOficinas, listaMunicipios] = await Promise.all([
          oficinasApi.listar({ includeInactive: false }),
          municipiosApi.listar({ includeInactive: false })
        ]);

        const resultado = resolverPendientes(listaOficinas, listaMunicipios);

        if (activo) {
          setOficinas(resultado);
          setEstado("correcto");
        }
      } catch (error) {
        if (activo) {
          console.warn("[IPD_CATALOGO_PENDIENTES]", error.message);
          setEstado("error");
        }
      }
    }

    consultar();

    return () => {
      activo = false;
    };
  }, []);

  return (
    <section
      aria-label="Oficinas pendientes de configuracion"
      data-testid="ipd-oficinas-pendientes"
      style={{
        margin: "18px 0",
        padding: 20,
        background: "#ffffff",
        border: "1px solid #dce5ef",
        borderRadius: 12
      }}
    >
      <h3 style={{ margin: 0, color: "#18324b", fontSize: 17 }}>
        Oficinas pendientes de configuracion
      </h3>

      <p style={{ color: "#64748b", fontSize: 13 }}>
        Registradas en el catalogo oficial, sin inventario operativo configurado.
      </p>

      {estado === "cargando" && <p>Consultando catalogo...</p>}

      {estado === "error" && (
        <p role="status">
          No fue posible consultar el catalogo oficial.
          El inventario operativo permanece disponible.
        </p>
      )}

      {estado === "correcto" && (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: 12
        }}>
          {oficinas.map(oficina => (
            <article key={oficina.id} style={{
              padding: 15,
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: 10
            }}>
              <strong style={{ color: "#1e293b" }}>
                {oficina.nombre}
              </strong>

              <div style={{ marginTop: 6, color: "#64748b", fontSize: 12 }}>
                {oficina.municipio}
              </div>

              <div style={{
                display: "inline-block",
                marginTop: 12,
                padding: "5px 9px",
                borderRadius: 6,
                background: "#e8eef5",
                color: "#475569",
                fontSize: 11
              }}>
                Pendiente de configuracion
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}